import { Flex, Text } from '@servicetitan/anvil2';
import { PropsWithChildren } from 'react';

interface MessageProps {
    headline: string;
    detail: string;
    className?: string;
}

export const Message = ({
    headline,
    detail,
    className,
    children,
}: PropsWithChildren<MessageProps>) => {
    return (
        <Flex direction="column" alignItems="center" gap="2" className={className}>
            <Text variant="headline" el="h3">
                {headline}
            </Text>
            <Text style={{ textAlign: 'center' }}>{detail}</Text>
            {children}
        </Flex>
    );
};
